<h1 class="mt-4 mb-0 text-muted">
    Tabelas
</h1>

<div class="">
    <router-outlet></router-outlet>
</div>